import { atom } from 'jotai/index';
import { IArticleComments, IArticleRelatedHashtag, IArticleRelatedPost } from 'shared/atoms';
import { IGalleryArticleDetail, IVideoArticleDetail, TArticleDetail } from 'shared/models';
import { PromiseOrValue } from 'shared/utils/promise-or-value';

const $CurrentArticle = atom({} as TArticleDetail);
const $CurrentVideoArticle = atom({} as IVideoArticleDetail);
const $CurrentGalleryArticle = atom({} as IGalleryArticleDetail);
const $CurrentArticleComments = atom({} as PromiseOrValue<IArticleComments>);
const $CurrentArticleRelatedPost = atom({} as PromiseOrValue<IArticleRelatedPost>);
const $CurrentArticleRelatedHashtag = atom({} as PromiseOrValue<IArticleRelatedHashtag>);
const $CurrentArticleFold = atom<boolean>(true);
const $CurrentArticleHeightComputed = atom<boolean>(false);

export const PostDetailModalAtoms = {
  $CurrentArticle,
  $CurrentVideoArticle,
  $CurrentGalleryArticle,
  $CurrentArticleComments,
  $CurrentArticleRelatedPost,
  $CurrentArticleRelatedHashtag,
  $CurrentArticleFold,
  $CurrentArticleHeightComputed,
};
